<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-center flex-row-fluid">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/assets/sass/pages/auth.scss";
</style>

<script>
export default {
  name: "Auth-Page",
};
</script>
